import { SpacingsValues } from '@picsart/cascade';
import { createUseStyles } from 'react-jss';

import { hideScrollbars, mediaQuery } from '../../../styles';
import { ITheme } from '../../../styles/theme';

export const GAP = 24;
export const MOBILE_GAP = 8;

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      paddingBlock: SpacingsValues.s56,
      marginBottom: 40,
      marginInline: 'auto',

      '& .brk': {
        display: 'block',
      },

      [mediaQuery(breakpoints.tablet)]: {
        paddingBlock: SpacingsValues.s40,
        marginBottom: 0,
      },
      [mediaQuery(breakpoints.mobile)]: {
        '& .brk': {
          display: 'inline',
        },
      },
    },
    title: {
      color: 'var(--x-black)',
      display: 'block',
      fontSize: 42,
      fontWeight: 500,
      lineHeight: '50px',
      marginBottom: 30,
      marginInline: 'auto',
      maxWidth: 896,
      paddingInline: SpacingsValues.s24,
      textAlign: 'center',

      [mediaQuery(breakpoints.tablet)]: {
        fontSize: 30,
        lineHeight: '36px',
        marginBottom: SpacingsValues.s24,
      },
    },
    subtitle: {
      textAlign: 'center',
      fontWeight: 500,
      color: '#5F5F5F',
      marginBottom: '32px',
    },
    tabs: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    tabButtons: {
      background: 'none',
      display: 'flex',
      flexWrap: 'nowrap',
      gap: SpacingsValues.s16,
      maxWidth: '100%',
      marginBottom: 28,
      paddingBlock: 4,
      paddingInline: 60,
      overflowX: 'auto',
      whiteSpace: 'nowrap',

      ...hideScrollbars,

      [mediaQuery(breakpoints.tablet)]: {
        flexWrap: 'nowrap',
        marginBottom: SpacingsValues.s24,
        overflowX: 'auto',
        paddingInline: SpacingsValues.s24,
      },
    },
    tabPanels: {
      width: '100vw',
    },
    tabContent: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: SpacingsValues.s40,

      [mediaQuery(breakpoints.tablet)]: {
        gap: SpacingsValues.s32,
        overflow: 'hidden',
      },
    },
    imgs: {
      width: '100%',
      overflowX: 'clip',
    },
    imgContainer: {
      alignSelf: 'flex-start',
      gap: GAP,
      transition: 'margin-left 0.5s ease-out',

      [mediaQuery(breakpoints.tablet)]: {
        gap: MOBILE_GAP,
      },
    },
    mobileImg: {
      display: 'none',
      [mediaQuery(breakpoints.tablet)]: {
        display: 'block',
      },
    },
    desktopImg: {
      display: 'block',
      [mediaQuery(breakpoints.tablet)]: {
        display: 'none',
      },
    },
    img: {
      [mediaQuery(breakpoints.tablet)]: {
        maxWidth: '100vw',
      },
    },
    description: {
      color: '#666',
      maxWidth: 896,
      paddingInline: SpacingsValues.s24,
      textAlign: 'center',
    },
    image: {
      width: '100%',
    },
    imgBackground: {
      alignItems: 'center',
      backgroundColor: '#f8f8f8',
      borderRadius: 56,
      display: 'flex',
      height: 470,
      justifyContent: 'center',
      width: 'min(100%, 900px)',

      [mediaQuery(breakpoints.tablet)]: {
        height: 'auto',
        padding: 8,
      },
    },
    imageWithBackground: {
      maxHeight: '100%',
      maxWidth: '100%',
    },
  }),
  {
    name: 'TabSection2',
  },
);

export default useStyles;
